<template>
  <v-container fluid class="mt-5">
    <v-row class="mb-8 titulo">
      <v-col>
        <h2>Dashboard Ligação com Obras</h2>
      </v-col>
    </v-row>

    <v-tabs v-model="tab" fixed-tabs color="primary">
      <v-tab :disabled="loadingInitFiltros || loadingDados">
        Geral
      </v-tab>
      <v-tab :disabled="loadingInitFiltros || loadingDados">
        Visão Aneel
      </v-tab>
      <v-tab :disabled="loadingInitFiltros || loadingDados">
        Municípios
      </v-tab>
    </v-tabs>

    <v-card
      class="my-0 parametros-v-card"
      :disabled="loadingInitFiltros || loadingDados"
    >
      <v-card-title>
        <h4>Parâmetros</h4>
      </v-card-title>
      <v-card-text>
        <v-row align="center" class="mx-1 mt-2 mb-4">
          <v-col cols="12" md="8" class="d-flex flex-wrap align-center">
            <app-field v-if="tab === 0" label="Período de Competência" class="mr-8 mb-2">
              <div class="d-flex align-center">
                <input-month
                  rules="min:7"
                  :minMonth="'2023-01'"
                  :selectedMonth="competenciaDe"
                  @monthSelected="setCompetenciaDe"
                  outlined
                  dense
                  class="mr-4"
                />
                <span class="font-weight-medium mx-3 grey--text body-2">
                  até
                </span>
                <input-month
                  rules="min:7"
                  :minMonth="'2023-01'"
                  :selectedMonth="competenciaAte"
                  @monthSelected="setCompetenciaAte"
                  outlined
                  dense
                />
              </div>
            </app-field>

            <app-field v-if="tab !== 0" label="Competência" class="mr-8 mb-2">
              <input-month
                rules="min:7"
                :minMonth="'2023-01'"
                :selectedMonth="competencia"
                @monthSelected="setCompetencia"
                outlined
                dense
              />
            </app-field>

            <app-field v-if="tab !== 0" label="Regional" class="mr-8 mb-2" style="min-width: 200px">
              <v-select
                :items="regionaisList"
                :value="regionalSelecionada"
                @change="setRegionalSelecionada"
                hide-details
                outlined
                dense
              />
            </app-field>
          </v-col>

          <v-col cols="12" md="4" class="d-flex justify-end align-center">
            <v-btn
              color="primary"
              outlined
              @click="dialogMetasKpis = true"
            >
              <v-icon left size="30px">
                mdi-open-in-app
              </v-icon>
              Gerenciar metas dos KPIs
            </v-btn>
          </v-col>
        </v-row>

        <v-row class="mx-1 mt-3" justify="space-between">
          <v-col class="py-0" cols="12" sm="6">
            <div class="body-2 grey--text">
              Tipo de cálculo:
              <dialog-tipos-calculos
                :dialog.sync="dialogTiposCalculos"
                :traducaoIndicadores="traducaoIndicadores"
              />
            </div>
            <v-radio-group
              v-model="tipoCalculoSelecionado"
              row
              class="my-0"
              hide-details
            >
              <v-radio label="LNO" value="lno" />
              <v-radio label="GD" value="gdis" />
              <v-radio label="LNO e GD" value="lno_gdis" />
            </v-radio-group>

            <div class="body-2 grey--text mt-4">Localização de Obras</div>
            <v-radio-group
              v-model="tipoLocalizacaoSelecionado"
              row
              class="my-0"
              hide-details
            >
              <v-radio label="Urbana" value="loc_obras_urbano" />
              <v-radio label="Rural" value="loc_obras_rural" />
              <v-radio label="Ambos" value="loc_obras_urbano_rural" />
            </v-radio-group>
          </v-col>
          <v-col v-if="tab === 1" cols="auto">
            <v-btn
              color="primary"
              outlined
              class="mt-2"
              @click="$refs.visaoAneel.exportDashboardToPdfDompdf()"
              :loading="exportingPdfVisaoAneel"
              :disabled="exportingPdfVisaoAneel"
            >
              <v-icon left size="30px">
                mdi-file-pdf-box
              </v-icon>
              Exportar PDF
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-progress-linear
      v-if="loadingInitFiltros || loadingDados"
      color="primary"
      indeterminate
      height="4"
      class="my-0"
      :style="
        tab === 2
          ? 'position: relative; top: 96px; z-index: 10; margin: 0 0px;'
          : null
      "
    />

    <dashboard-lno-geral
      v-if="
        !loadingInitFiltros &&
          tab === 0 &&
          competenciaDe != '' &&
          competenciaAte != ''
      "
      :competenciaDe="competenciaDe"
      :competenciaAte="competenciaAte"
      :tipoCalculo="tipoCalculo"
      :activatedTab="tab"
      :traducaoIndicadores="traducaoIndicadores"
      @updateLoadingDados="loadingDados = $event"
      :tipoLocalizacao="tipoLocalizacao"
    />

    <dashboard-lno-visao-aneel
      v-if="
        !loadingInitFiltros &&
          tab === 1 &&
          competencia != '' &&
          regionalSelecionadaId !== 0
      "
      ref="visaoAneel"
      :competencia="competencia"
      :tipoCalculo="tipoCalculo"
      :categories="categories"
      :categoriesResultadoAtual="categoriesResultadoAtual"
      :categoriesResultadoAnterior="categoriesResultadoAnterior"
      :activatedTab="tab"
      :traducaoIndicadores="traducaoIndicadores"
      :regionalSelecionadaId="regionalSelecionadaId"
      @updateLoadingDados="loadingDados = $event"
      @updateExportingPdfVisaoAneel="exportingPdfVisaoAneel = $event"
      :tipoLocalizacao="tipoLocalizacao"
    />
    <dashboard-lno-visao-municipios
      v-if="
        !loadingInitFiltros &&
          tab === 2 &&
          competencia != '' &&
          regionalSelecionadaId !== 0
      "
      :competencia="competencia"
      :tipoCalculo="tipoCalculo"
      :activatedTab="tab"
      :traducaoIndicadores="traducaoIndicadores"
      :regionalSelecionadaId="regionalSelecionadaId"
      @updateLoadingDados="loadingDados = $event"
      :tipoLocalizacao="tipoLocalizacao"
    />

    <dialog-gerenciamento-metas-kpis
      v-if="dialogMetasKpis"
      :dialog.sync="dialogMetasKpis"
      ref="metasKpis"
      @importaMetasKpis="importaMetasKpis()"
      @baixarMetasKpis="baixarMetasKpis($event)"
    >
      <template v-slot:cadatro-geral-extra-info>
        Deve conter as colunas:
        <span class="font-weight-bold"
          >mes; ano; qlp; pla; pmea; pat1; pat2; pat3; pat4</span
        >
      </template>
      <template v-slot:cadatro-municipios-extra-info>
        Deve conter as colunas:
        <span class="font-weight-bold"
          >codigo_municipio; mes; ano; qlp; pla; pmea; pat1; pat2; pat3;
          pat4</span
        >
      </template>
    </dialog-gerenciamento-metas-kpis>
  </v-container>
</template>

<script>
import DashboardLnoService from "@/services/DashboardLnoService";
import MunicipiosService from "@/services/MunicipiosService";

import {
  generateMonthlyDateRangeArray,
  generateMonthlyDateRangeArrayPortuguese,
} from "@/utils/dateUtils.js";

import Highcharts from "highcharts";
import HighchartsNoData from "highcharts/modules/no-data-to-display";
HighchartsNoData(Highcharts);
import dayjs from "dayjs";
import { mapActions, mapState } from "vuex";

export default {
  name: "DashboardLno",
  components: {
    InputMonth: () => import("@/components/general/InputMonth.vue"),
    DashboardLnoGeral: () =>
      import("@/components/dashboardLno/DashboardLnoGeral.vue"),
    DashboardLnoVisaoAneel: () =>
      import("@/components/dashboardLno/DashboardLnoVisaoAneel.vue"),
    DashboardLnoVisaoMunicipios: () =>
      import("@/components/dashboardLno/DashboardLnoVisaoMunicipios.vue"),
    DialogGerenciamentoMetasKpis: () =>
      import("@/components/paineisGerenciais/DialogGerenciamentoMetasKpis.vue"),
    DialogTiposCalculos: () =>
      import("@/components/dashboardLno/DialogTiposCalculos.vue"),
  },
  data: () => ({
    tab: 1,
    regionais: [],
    dialogMetasKpis: false,
    loadingInitFiltros: true,
    loadingDados: false,
    exportingPdfVisaoAneel: false,
    traducaoIndicadores: {
      qlp: "Quantidade de Ligações com obra pendentes não suspensas",
      pla: "Percentual de ligações com obra atrasadas",
      "pla+e": "Percentual de ligações com obra atrasadas (com Estudo)",
      pmea:
        "Prazo Médio Ligação Pendente P/ Elab. de Est., Orç. e Projetos Atrasado",
      pmea2:
        "Prazo Médio Ligação Pendente P/ Elab. de Est., Orç. e Projetos Atrasado (2)",
      pmea15: "Prazo Médio de Estudos Atrasados (15 dias)",
      pmea30: "Prazo Médio de Estudos Atrasados (30 dias)",
      pmea45: "Prazo Médio de Estudos Atrasados (45 dias)",
      pat1: "Prazo Médio de Ligação Atrasada do Tipo 1",
      pat2: "Prazo Médio de Ligação Atrasada do Tipo 2",
      pat3: "Prazo Médio de Ligação Atrasada do Tipo 3",
      pat4: "Prazo Médio de Ligação Atrasada do Tipo 4",
      ilp: "Índice de Ligação com Obra Pendente",
    },
    dialogTiposCalculos: false,
    progressFixedStyle: "position:fixed;left:0;right:0;bottom:0;z-index:2000;",
  }),
  computed: {
    ...mapState("parametrosDashboardLno", [
      "competenciaDe",
      "competenciaAte",
      "competencia",
      "regionalSelecionada",
      "tipoCalculo",
      "tipoLocalizacao",
    ]),
    regionaisList() {
      return this.regionais.map((el) => el.nome);
    },
    regionalSelecionadaId() {
      let regional = this.regionais.find(
        (element) => element.nome == this.regionalSelecionada,
      );
      return regional == undefined ? 0 : regional.id;
    },
    categories() {
      const startDate = "2023-01";
      const endDate = dayjs().format("YYYY-MM");
      return generateMonthlyDateRangeArrayPortuguese(
        startDate,
        endDate,
        "YYYY-MM",
      );
    },
    categoriesResultadoAtual() {
      const startDate = this.competencia.split("-")[0] + "-" + "01";
      const endDate = startDate.split("-")[0] + "-" + "12";
      return generateMonthlyDateRangeArray(startDate, endDate, "YYYY-MM");
    },
    categoriesResultadoAnterior() {
      const startDate =
        dayjs(this.competencia)
          .subtract(1, "year")
          .format("YYYY-MM")
          .split("-")[0] +
        "-" +
        "01";
      const endDate = startDate.split("-")[0] + "-" + "12";
      return generateMonthlyDateRangeArray(startDate, endDate, "YYYY-MM");
    },
    tipoCalculoSelecionado: {
      get() {
        return this.tipoCalculo;
      },
      set(newValue) {
        this.setTipoCalculo(newValue);
      },
    },
    tipoLocalizacaoSelecionado: {
      get() {
        return this.tipoLocalizacao;
      },
      set(newValue) {
        this.setTipoLocalizacao(newValue);
      },
    },
  },
  async created() {
    await this.initFiltros();
  },
  methods: {
    ...mapActions("parametrosDashboardLno", [
      "setRangeCompetencias",
      "setCompetenciaDe",
      "setCompetenciaAte",
      "setCompetencia",
      "setRegionalSelecionada",
      "setTipoCalculo",
      "setTipoLocalizacao",
    ]),
    async initFiltros() {
      this.loadingInitFiltros = true;
      try {
        this.setRangeCompetencias();
        await this.getRegionais();
      } finally {
        this.loadingInitFiltros = false;
      }
    },
    importaMetasKpis() {
      const ref = this.$refs.metasKpis;

      ref.loading = true;

      DashboardLnoService.importarMetasKpis(
        ref.tipoDeCadastro,
        ref.lastUploadedFile.id,
      )
        .then((res) => {
          this.$toast.success("Metas salvas com sucesso", "", {
            position: "topRight",
          });
          ref.uploadedFiles = [];
          ref.dialogLocal = false;
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Erro ao salvar metas", "", {
            position: "topRight",
          });
        })
        .finally(() => (ref.loading = false));
    },
    baixarMetasKpis(tipoDeCadastro) {
      const ref = this.$refs.metasKpis;

      ref.loading = true;

      DashboardLnoService.baixarMetasKpis(tipoDeCadastro, {
        timeout: 60 * 60 * 1000,
      })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Metas dos KPIs - ${tipoDeCadastro}.xlsx`,
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Erro ao baixar Metas dos KPIs", "", {
            position: "topRight",
          });
        })
        .finally(() => (ref.loading = false));
    },
    getRegionais() {
      return MunicipiosService.getRegionais()
        .then((res) => {
          this.regionais = res;
          if (this.regionalSelecionada == null) {
            this.setRegionalSelecionada(
              res.find((el) => el.nome.toLowerCase() == "distribuidora").nome,
            );
          }
        })
        .catch((err) => {
          throw err;
        });
    },
  },
  watch: {},
};
</script>

<style>
.parametros-v-card {
  box-shadow: 0px 0px 0px !important;
}
.v-tab {
  text-transform: none !important;
}
.titulo {
  font-family: "styrene A";
  font-weight: 500;
  color: #3c4858 !important;
  font-size: 18px !important;
}
</style>
